import React from "react";
import LoginImg from "../../img/loginImg.gif";
// import LoginImg from "../../img/loginImg.gif";
import LoginBirdView from "../../img/LoginBirdView.png";
import cloud from "../../img/cloud.png";
const ImageDiv = ({ inputFocus }) => {
  return (
    <div
      className="image-slider"
      style={{
        borderRadius: "8px",
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Animated Image: Slides left to right */}
      <div
        className="slider-container"
        style={{ position: "absolute", top: 0, left: 0, zIndex: 10 }}
      >
        <img
          src={cloud}
          alt="Sliding"
          className="sliding-image"
          style={{
            opacity: inputFocus ? 0 : 1,
            transition: "opacity 0.8s ease-in-out, transform 0.8s ease-in-out",
            transform: inputFocus ? "scale(3.5)" : "scale(1)",
          }}
        />{" "}
        <img
          src={cloud}
          alt="Sliding"
          className="sliding-image"
          style={{
            opacity: inputFocus ? 0 : 1,
            transition: "opacity 0.8s ease-in-out, transform 0.8s ease-in-out",
            transform: inputFocus ? "scale(3.5)" : "scale(1)",
          }}
        />
        <img
          src={cloud}
          alt="Sliding"
          className="sliding-image second"
          style={{
            opacity: inputFocus ? 0 : 1,
            transition: "opacity 0.8s ease-in-out, transform 0.8s ease-in-out",
            transform: inputFocus ? "scale(3.5)" : "scale(1)",
          }}
        />
        <img
          src={cloud}
          alt="Sliding"
          className="sliding-image-bg"
          style={{
            opacity: inputFocus ? 0 : 1,
            transition: "opacity 0.8s ease-in-out, transform 0.8s ease-in-out",
            transform: inputFocus ? "scale(3.5)" : "scale(1)",
          }}
        />
      </div>

      {/* Image 1: BirdView */}
      <img
        src={LoginBirdView}
        alt="LoginBirdView"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          borderRadius: "8px",
          height: "100%",
          objectFit: "cover",
          transition: "opacity 0.8s ease-in-out, transform 0.8s ease-in-out",
          opacity: inputFocus ? 0 : 1,
          transform: inputFocus ? "scale(1.5)" : "scale(1)",
          zIndex: 5,
        }}
      />
      {/* Image 2: Login Image (Zooms in when inputFocus is true) */}
      <img
        src={LoginImg}
        alt="LoginImg"
        style={{
          position: "absolute",
          borderRadius: "8px",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          transition: "opacity 0.8s ease-in-out, transform 0.8s ease-in-out",
          opacity: inputFocus ? 1 : 0,
          transform: inputFocus ? "scale(1)" : "scale(1.5)",
          zIndex: 5,
        }}
      />
    </div>
  );
};

export default ImageDiv;
